<template>
	<div class="page-one index-page">
		<div class="index-page-content">
			<div class="index-top-bar">
				<div class="index-top-title"></div>
				<div class="index-top-constellation">
					<constellation-panel></constellation-panel>
				</div>
				<div class="index-top-bottom-bar"></div>
			</div>
			<div class="index-bottom-part">
				<!-- 2. 表单部分 -->
				<div class="index-main-content-box">
					<div class="index-main-content">
						<!-- 2.1 选择时间组件 -->
						<birthday-panel></birthday-panel>
						<!-- 2.2  -->
						<div class="index-mc-line index-mc-line2">
							<span class="dot"></span>
							<span class="index-mc-title">昵称：</span>
							<input class="index-mc-input" type="text" maxlength="20" v-model="nickname" @input="inputNickname" />
						</div>
						<!-- 2.3  -->
						<div class="index-mc-line">
							<span class="dot"></span>
							<span class="index-mc-title">性别：</span>
							<div class="index-mc-gender-box">
								<span class="index-mc-gender" :class="{'cur': inputData.gender == 0}" @click="toggleGender(0)"><span class="iconfont icon-male"></span>男</span>
								<span class="index-mc-gender" :class="{'cur': inputData.gender == 1}" @click="toggleGender(1)"><span class="iconfont icon-female"></span>女</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 3. 按钮部分 -->
				<div class="index-main-button-box">
					<div class="index-main-button" @click="clickStart">看我卯力有多足</div>
					<!-- <div class="index-main-btext">只有一次机会，请确认好生日</div> -->
					<div class="index-main-button-two" @click="clickRecord"><span>测算<br/>记录</span></div>
				</div>
				<!-- <div class="index-copyright">
					<div class="index-main-btext">*活动最终解释权由连云港桃花涧景区所有</div>
				</div> -->
			</div>

		</div>
		<!-- 1. 顶部部分 -->
		<!-- todo用户列表 -->
		<!-- <userlist-panel></userlist-panel> -->
		
		<!-- 静音按钮 -->
		<audio-button></audio-button>
	</div>
</template>

<script>
	import { WEIXIN } from '../modules/weixin'
	import UserlistPanel from '../components/common/UserlistPanel.vue'
	import ConstellationPanel from '../components/common/ConstellationPanel.vue'
	import BirthdayPanel from '../components/common/BirthdayPanel.vue'
	import AudioButton from '../components/common/AudioButton.vue'
	export default {
		components: { UserlistPanel, ConstellationPanel, BirthdayPanel, AudioButton },
		computed: {
			inputData() {
				return this.$store.state.user.inputData;
			}
		},
		data() {
			return {
				height: 600,
				locked: false,
				nickname: '',
			}
		},
		mounted() {
			setTimeout(function() {
				this.initDom();
				this.$store.dispatch('pay/getProductList', {type: 2});
				this.$bus.emit('playReportAudio');
			}.bind(this), 1000);
		},
		methods: {
			initDom() {
				this.$el.style.height = innerHeight+'px';
			},
			inputNickname() {
				this.$set(this.$store.state.user.inputData, 'nickname', this.nickname);
			},
			toggleGender(gender) {
				this.$set(this.$store.state.user.inputData, 'gender', gender);
			},
			clickStart() {
				// var me = this;
				// this.$store.dispatch('user/getUserHomePageData', {
				// 	cb: function() {
				// 		me.$router.replace('/report');
				// 	}
				// });
				// return;
				// this.$store.state.user.gotUserPageData = true;
				// this.$set(this.$store.state.user.inputData, 'gender', 1);
				// this.$router.replace('/generate');
				// return;
				var me = this;
				let userData = this.$store.state.userData;
				if(!userData || !userData.token) {
					this.$toast('请先扫码登录~');
					window.location = WEIXIN.getWechatAuthUrl();
					return;
				}
				this.$bus.emit('checkBithCalendar', {
					cb: function() {
						var nickname = this.inputData.nickname, 
							gender = this.inputData.gender;
						console.error('nickname-----', nickname, gender)
						if(!nickname || nickname == '') {
							me.$toast('请输入昵称哟~');
							return;
						}
						if(gender < 0) {
							me.$toast('请选择您的性别哟~');
							return;
						}
						if(this.locked) { return; }
						this.locked = true;
						// 发起添加请求
						this.$store.dispatch('user/addUser', {
							cb: function(cData) {
								this.$store.dispatch('user/getUserHomePageData', {
									id: cData.id,
									cb: function() {
										// 跳转到过渡页面
										me.$router.replace('/generate');
									}
								})
								this.locked = false;
							}.bind(this)
						});
						setTimeout(function() {
							this.locked = false;
						}.bind(this), 5000)
					}.bind(this)
				});
			},
			clickRecord() {
				let userData = this.$store.state.userData;
				if(!userData || !userData.token) {
					this.$toast('请先扫码登录~');
					window.location = WEIXIN.getWechatAuthUrl();
					return;
				}
				this.$router.replace('/record');
			}
		}
	}
</script>

<style></style>
	